export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  // {
  //   path: '/error-404',
  //   name: 'misc-not-authorized',
  //   component: () => import('@/views/error/Error404.vue'),
  //   meta: {
  //     layout: 'full',
  //     resource: 'Auth',
  //     action: 'read',
  //   },
  // },
  {
    path: '/callback-login',
    name: 'callback-login',
    component: () => import('@/views/general/authentication/Callback.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/general/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/general/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/general/profile/Profile.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Home',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },
]
